import _ from 'lodash';
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../themes';
import genericPlusIcon from '../images/icons/genericPlus.svg';
import { Link } from 'react-router-dom';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		pickerCardPaper: {
			height: '100%',
		},
		pickerCardPadding: {
			padding: 30,
		},
		pickCardTitleContainer: {
			paddingTop: 10,
			display: 'flex',
			alignContent: 'center',
			alignItems: 'center',
			paddingBottom: 30,
		},
		pickerCardTitle: {
			paddingLeft: 10,
			fontSize: 28,
			color: '#333',
		},
		driverReportIcon: {
			width: 50,
		},
		pickerCardDescriptionLabel: {
			textTransform: 'uppercase',
			color: '#999',
			fontSize: 16,
		},
		pickerCardDescription: {
			fontSize: 18,
		},
		pickerCardButtonContainer: {
			textAlign: 'right',
			paddingTop: 30,
		},
		pickerCardButton: {
			paddingRight: 55,
			paddingLeft: 55,
			fontSize: 18,
		},
		sectionLabel: {
			fontSize: 13,
			fontWeight: 600,
			textTransform: 'uppercase',
			color: '#999',
			letterSpacing: 1,
			marginTop: 32,
			marginBottom: 8,
		},
	};
};

const PickerCard = (props) => {
	const { classes, title, description, url, icon, disabled } = props;
	return (
		<Paper className={classes.pickerCardPaper}>
			<div className={classes.pickerCardPadding}>
				<div className={classes.pickCardTitleContainer}>
					<img alt="Action Icon" src={icon} className={classes.driverReportIcon} />
					<span className={classes.pickerCardTitle}>{title}</span>
				</div>
				<div>
					<div className={classes.pickerCardDescriptionLabel}>Description</div>
					<div className={classes.pickerCardDescription}>{description}</div>

					<div className={classes.pickerCardButtonContainer}>
						<Link to={url} style={{ textDecoration: 'none' }}>
							<Button
								variant="contained"
								color="primary"
								aria-label="Add"
								size="large"
								className={classes.pickerCardButton}
								disabled={disabled}
							>
								Open
							</Button>
						</Link>
					</div>
				</div>
			</div>
		</Paper>
	);
};

const CARDS = [
	{
		section: 'Users',
		items: [
			{
				title: 'Add New User',
				url: '/user/add',
				description:
					'Set up new users in the Sphere system so they can take advantage of all the tools Sphere has to offer.',
			},
			{
				title: 'Manage Users',
				url: '/users',
				description:
					'View, search, and update existing user accounts, roles, and permissions across the organization.',
			},
		],
	},
	{
		section: 'Fleet',
		items: [
			{
				title: 'Fleet Config',
				url: '/fleetConfig',
				description:
					'View the mapping of fleet departments to their terminal managers, terminal admins, and mechanics.',
			},
			{
				title: 'Terminals',
				url: '/location/truck-terminal',
				description:
					'Manage terminal locations including addresses, contacts, and operational details for each site.',
			},
			{
				title: 'Trucks',
				url: '/equipment/truck',
				description:
					'Manage the truck and equipment inventory — add, update, or retire vehicles across all terminals.',
			},
		],
	},
	{
		section: 'Tickets',
		items: [
			{
				title: 'Ticket Categories',
				url: '/ticketCategory/list',
				description:
					'Manage ticket categories, set default assignments, and configure which schema each category uses.',
			},
			{
				title: 'Ticket Schemas',
				url: '/ticketSchema/list',
				description:
					'Build and maintain the custom form schemas that define the fields on each type of ticket.',
			},
		],
	},
	{
		section: 'Scheduling',
		items: [
			{
				title: 'Schedule Config',
				url: '/scheduleConfig',
				description:
					'View schedule configurations and cycle day layouts for each user assignment type.',
			},
			{
				title: 'Driver Room Schedule',
				url: '/setupDriverRoomSchedule/',
				description:
					'Configure the driver room scheduling rules and slot assignments for each terminal.',
			},
			{
				title: 'Journey Plans',
				url: '/journeyPlan/list',
				description:
					'Manage journey plan configurations that define routes and stops for driver assignments.',
			},
		],
	},
	{
		section: 'Time Clocks',
		items: [
			{
				title: 'Supervisor Permissions',
				url: '/timeClockPermission/list',
				description:
					'Grant or revoke supervisor-level time clock permissions, controlling who can approve and adjust shifts.',
			},
		],
	},
	{
		section: 'System',
		items: [
			{
				title: 'Authorize Browser',
				url: '/authorizeBrowser',
				description:
					'Authorize specific browsers for driver login, enabling kiosk-style clock-in terminals at each location.',
			},
			{
				title: 'Code Logic',
				url: '/codeLogic',
				description:
					'View and inspect the business logic rules and code configuration used throughout the system.',
			},
			{
				title: 'GeoTab Group Config',
				url: '/geoTabGroupConfig',
				description:
					'View the GeoTab group collection and which groups belong to Superior vs Williams.',
			},
		],
	},
];

class Administration extends Component {
	render() {
		const { classes } = this.props;

		return (
			<Fragment>
				<div className={classes.globalMainHeadline}>Company Administration</div>

				{CARDS.map(({ section, items }) => (
					<Fragment key={section}>
						<div className={classes.sectionLabel}>{section}</div>
						<Grid container spacing={2}>
							{items.map((item) => (
								<Grid key={item.url} item xs={12} sm={6} md={4}>
									<PickerCard
										classes={classes}
										url={item.url}
										title={item.title}
										icon={genericPlusIcon}
										description={item.description}
									/>
								</Grid>
							))}
						</Grid>
					</Fragment>
				))}
			</Fragment>
		);
	}
}

Administration.propTypes = {
	classes: PropTypes.object.isRequired,
	authUser: PropTypes.object,
};

export default _.flow([withStyles(styles)])(Administration);
